import { createAction } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { PhoneRegisterListItem } from '../../models/phone-register-results.model';

const area = 'Phone Register';
export const phoneRegisterAdapterActions = createRegisterActions<PhoneRegisterListItem>(area);

export const createPhone = createAction('[Phone Register] Create Phone');
